/**
 * DS Cross-Sell Box – Product Page
 * Handles toggle, color matching on variant change, combined ATC, GA4 tracking.
 * V1: 5-Stage Color Match, iOS Toggle, Combined ATC, GA4.
 * Depends on: snippets/ds-cross-sell.liquid (JSON config + HTML)
 */
(function() {
  'use strict';

  var root = document.querySelector('[data-ds-cross-sell]');
  if (!root) return;

  var configEl = document.querySelector('[data-ds-cross-sell-config]');
  if (!configEl) return;

  var config;
  try { config = JSON.parse(configEl.textContent); } catch(e) { return; }

  /* ── DOM refs ── */
  var toggle   = root.querySelector('[data-ds-cs-toggle]');
  var imgEl    = root.querySelector('[data-ds-cs-img]');
  var nameEl   = root.querySelector('[data-ds-cs-name]');
  var priceEl  = root.querySelector('[data-ds-cs-price]');
  var origEl   = root.querySelector('[data-ds-cs-original]');
  var savingsEl= root.querySelector('[data-ds-cs-savings]');

  /* ── State ── */
  var isOn = true;
  var currentVariant = findVariant(config.initialVariantId);
  var mainPrice = config.mainVariantPrice;

  /* ── Synonym map (same as Liquid) ── */
  var synonyms = {
    'gray':'grau','grey':'grau','grau':'grau',
    'fuchsia':'fuchsie','fuchsie':'fuchsie',
    'ruby':'rubin','rubin':'rubin',
    'black':'schwarz','schwarz':'schwarz',
    'brown':'braun','braun':'braun',
    'white':'weiss','weiss':'weiss',
    'red':'rot','rot':'rot',
    'blue':'blau','blau':'blau',
    'green':'gruen','gruen':'gruen',
    'pink':'rosa','rosa':'rosa',
    'purple':'lila','lila':'lila','violet':'lila',
    'silver':'silber','silber':'silber',
    'turquoise':'tuerkis','tuerkis':'tuerkis',
    'coral':'koralle','koralle':'koralle',
    'ivory':'elfenbein','elfenbein':'elfenbein',
    'burgundy':'bordeaux','bordeaux':'bordeaux',
    'navy':'marine','marine':'marine',
    'cognac':'cognac','mint':'mint','beige':'beige',
    'anthrazit':'anthrazit','taupe':'taupe',
    'khaki':'khaki','orange':'orange','gold':'gold',
    'creme':'creme','cream':'creme'
  };

  /* ── Helpers ── */
  function findVariant(id) {
    for (var i = 0; i < config.crossProduct.variants.length; i++) {
      if (config.crossProduct.variants[i].id === id) return config.crossProduct.variants[i];
    }
    return config.crossProduct.variants[0];
  }

  function formatMoney(cents) {
    var val = (cents / 100).toFixed(2).replace('.', ',');
    return val + ' \u20AC';
  }

  function discountedPrice(cents) {
    if (config.discountPercent <= 0) return cents;
    return Math.round(cents * (100 - config.discountPercent) / 100);
  }

  function normalize(color) {
    return (color || '').toLowerCase().replace(' air mesh', '').trim();
  }

  function synonym(color) {
    var n = normalize(color);
    return synonyms[n] || n;
  }

  /* ── 5-Stage Color Match (JS version) ── */
  function matchColor(mainColor) {
    if (!mainColor || config.colorOptionIndex < 0 || !config.colorMatch) return null;

    var mc = mainColor.toLowerCase();
    var mcNorm = normalize(mc);
    var mcSyn = synonym(mc);
    var best = null;
    var bestQ = 0;

    for (var i = 0; i < config.crossProduct.variants.length; i++) {
      var v = config.crossProduct.variants[i];
      if (!v.available) continue;
      var vc = (v.options[config.colorOptionIndex] || '').toLowerCase();

      // Stage 4: exact
      if (vc === mc) return v;

      // Stage 3: normalized
      if (bestQ < 3) {
        var vcNorm = normalize(vc);
        if (vcNorm === mcNorm && vcNorm !== '') { best = v; bestQ = 3; }
      }

      // Stage 2: synonym
      if (bestQ < 2) {
        var vcSyn = synonym(vc);
        if (vcSyn === mcSyn && vcSyn !== '') { best = v; bestQ = 2; }
      }

      // Stage 1: contains
      if (bestQ < 1) {
        var vcN2 = normalize(vc);
        if (mcNorm.length >= 3 && vcN2.length >= 3) {
          if (vcN2.indexOf(mcNorm) !== -1 || mcNorm.indexOf(vcN2) !== -1) {
            best = v; bestQ = 1;
          }
        }
      }
    }
    return best;
  }

  /* ── Main-Variant Lookup (Defense gegen verschluckte variant:change Events) ── */
  function findMainVariantById(id) {
    if (!config.mainVariants || !id) return null;
    var idNum = parseInt(id, 10);
    for (var i = 0; i < config.mainVariants.length; i++) {
      if (config.mainVariants[i].id === idNum) return config.mainVariants[i];
    }
    return null;
  }

  function getMainFormVariantId() {
    var form = findProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="id"], select[name="id"]');
    return input ? input.value : null;
  }

  /**
   * Re-evaluate cross-sell variant from current main-form state.
   * Used as defense when variant:change events are missed (mobile touch quirks).
   */
  function refreshCrossSellVariant() {
    var mainId = getMainFormVariantId();
    if (!mainId) return;
    var mainVariant = findMainVariantById(mainId);
    if (!mainVariant) return;

    var matched = null;
    if (config.mainColorOptionIndex >= 0 && config.colorMatch) {
      var mainColor = mainVariant.options[config.mainColorOptionIndex];
      matched = matchColor(mainColor);
    }
    if (!matched && config.mainSizeOptionIndex >= 0 && config.sizeOptionIndex >= 0) {
      var mainSize = mainVariant.options[config.mainSizeOptionIndex];
      matched = matchSize(mainSize);
    }
    if (matched && matched.id !== currentVariant.id) {
      currentVariant = matched;
      updateUI();
    }
  }

  /* ── Update UI ── */
  function updateUI() {
    var dp = discountedPrice(currentVariant.price);
    priceEl.textContent = formatMoney(dp);

    if (origEl) {
      if (config.discountPercent > 0) {
        origEl.textContent = 'statt ' + formatMoney(currentVariant.price);
        origEl.style.display = '';
      } else {
        origEl.style.display = 'none';
      }
    }

    if (savingsEl) {
      var savings = currentVariant.price - dp;
      if (savings > 0) {
        savingsEl.textContent = '\u00B7 Du sparst ' + formatMoney(savings);
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }

    if (imgEl && currentVariant.image) {
      imgEl.src = currentVariant.image;
    }

    // Expose current variant ID for other consumers (ds-cart-bar.js sticky ATC)
    if (currentVariant && currentVariant.id) {
      root.setAttribute('data-current-variant-id', String(currentVariant.id));
    }
  }

  /* ── Toggle ── */
  toggle.addEventListener('click', function() {
    isOn = !isOn;
    toggle.setAttribute('aria-checked', isOn ? 'true' : 'false');
    ga4('ds_cross_sell_toggle', { state: isOn ? 'on' : 'off' });
  });

  /* ── Size Match (for accessories like Ersatzschalen) ── */
  function matchSize(mainSize) {
    if (!mainSize || config.sizeOptionIndex < 0) return null;
    var ms = mainSize.toLowerCase();
    var best = null;

    for (var i = 0; i < config.crossProduct.variants.length; i++) {
      var v = config.crossProduct.variants[i];
      if (!v.available) continue;
      var vs = (v.options[config.sizeOptionIndex] || '').toLowerCase();

      // Exact match (S==S, M==M)
      if (vs === ms) return v;

      // Contains match (L/XL contains L, L/XL contains XL)
      if (vs.indexOf(ms) !== -1) best = v;
    }
    return best;
  }

  /* ── Variant Change Listener ── */
  document.addEventListener('variant:change', function(e) {
    if (!e.detail || !e.detail.variant) return;
    var newVariant = e.detail.variant;
    mainPrice = newVariant.price;

    var matched = null;

    // Try color matching first
    if (config.mainColorOptionIndex >= 0 && config.colorMatch) {
      var newColor = newVariant.options[config.mainColorOptionIndex];
      matched = matchColor(newColor);
    }

    // Fallback: size matching (for accessories without color options)
    if (!matched && config.mainSizeOptionIndex >= 0 && config.sizeOptionIndex >= 0) {
      var newSize = newVariant.options[config.mainSizeOptionIndex];
      matched = matchSize(newSize);
    }

    if (matched && matched.id !== currentVariant.id) {
      currentVariant = matched;
      ga4('ds_cross_sell_variant_match', {
        cross_variant_id: matched.id
      });
    }

    updateUI();
  });

  /* ── ATC Interception ── */
  function findProductForm() {
    // Find the main product form (not inside the cross-sell box)
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!root.contains(forms[i])) return forms[i];
    }
    return null;
  }

  var productForm = findProductForm();
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      if (!isOn) return; // Let normal flow handle it

      e.preventDefault();
      e.stopImmediatePropagation();

      // Defense: re-sync cross-sell variant from current main-form state
      // (variant:change events get swallowed on mobile color-swatch touches)
      refreshCrossSellVariant();

      // Get the main product variant ID from the form
      var mainIdInput = productForm.querySelector('input[name="id"], select[name="id"]');
      if (!mainIdInput) return;
      var mainVariantId = mainIdInput.value;

      // Read selling_plan for subscription support (main product only)
      var mainItem = { id: parseInt(mainVariantId, 10), quantity: 1 };
      var spId = window.__dsSellingPlan && window.__dsSellingPlan.id ? window.__dsSellingPlan.id : null;
      if (!spId) {
        var spInput = productForm.querySelector('input[name="selling_plan"]');
        if (spInput && spInput.value) spId = parseInt(spInput.value, 10);
      }
      if (spId) mainItem.selling_plan = spId;

      var items = [
        mainItem,
        { id: currentVariant.id, quantity: 1, properties: { '_upsell': '1' } }
      ];

      // Disable form during request
      var submitBtn = productForm.querySelector('[type="submit"], button.product-form__submit, .product-form__submit');
      if (submitBtn) submitBtn.setAttribute('disabled', '');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-DS-Source': 'cross-sell' },
        body: JSON.stringify({ items: items })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        ga4('ds_cross_sell_add', {
          source: 'product_page',
          main_variant_id: parseInt(mainVariantId, 10),
          cross_variant_id: currentVariant.id,
          cross_product_id: config.crossProduct.id,
          discount_percent: config.discountPercent
        });

        // Dispatch event for cart drawer / badge update
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { items: data.items || data }
        }));
      })
      .catch(function(err) {
        console.error('[ds-cross-sell] ATC error:', err);
        // Fallback: submit form normally
        isOn = false;
        productForm.submit();
      })
      .finally(function() {
        if (submitBtn) submitBtn.removeAttribute('disabled');
      });
    }, true); // capture phase — fires before theme.js
  }

  /* ── GA4 Helper ── */
  function ga4(event, params) {
    // Änderung E: gtag() ENTFERNT — würde GA4 double-counting verursachen (DS.trackEvent pusht auf dataLayer, GTM feuert GA4)
    if (window.DS && window.DS.trackEvent) {
      window.DS.trackEvent(event, params || {});
    }
  }

  /* ── View Tracking (IntersectionObserver) ── */
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        ga4('ds_cross_sell_view', {
          cross_product_id: config.crossProduct.id,
          cross_product_title: config.crossProduct.title,
          discount_percent: config.discountPercent
        });
        obs.disconnect();
      }
    }, { threshold: 0.5 });
    obs.observe(root);
  }

  /* ── Click-Backup für Variant-Selektoren (variant:change feuert nicht immer auf Mobile) ── */
  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t) return;
    // Variant-Radio/Label, Color-Swatch, oder Variant-Select-Option
    var isVariantTrigger =
      t.closest('[data-color-swatch], .color-swatch, [data-variant-input]') ||
      t.matches('input[type="radio"][name^="option"], input[type="radio"][name="Farbe"], input[type="radio"][name="Größe"]') ||
      t.closest('label[for*="option"], label[for*="ProductSelect"], label[for*="swatch"]');
    if (!isVariantTrigger) return;
    // Delay damit Theme.js _onSelectChange das form[name="id"] erst aktualisiert hat
    setTimeout(refreshCrossSellVariant, 250);
  }, true);

  /* ── Init ── */
  updateUI();
  // Initial-Sync nach DOM-Settle (falls Theme.js ms später ?variant= Auto-Selection macht)
  setTimeout(refreshCrossSellVariant, 100);
})();
